<template>
<div>
   <!--  <p class="welcome-text">Welcome to The Republic of Accounting, this is your message board under Business Set-up. Fname Lname is your designated, please feel free to send your send your queries</p> -->
    <div class="col chat-box">
        <div class="col chat-window thin-scroll" ref="messagesContainer">
            <div v-for="msg in chat" :key="msg.id" >
                <div class="row m-t-30" v-if="msg.sender=='admin'">
                    <div class="col-sm-7 message-box-inner">
                        <div class="person-img user-img">
                            <img src="../assets/roa_icon.png" class="img-responsive">
                        </div>
                        <div class="person-text">
                            <small class="msg-details">{{msg.created_at | FormatDate('MM/DD/YYYY hh:mm a')}}</small>
                            <p>
                                {{msg.message}}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="row m-t-30" v-else>
                    <div class="col-sm-5">
                    </div>
                    <div class="col-sm-7 message-box-inner chat-right-me">

                        <div class="person-text1">
                            <small class="msg-details">{{msg.created_at | FormatDate('MM/DD/YYYY hh:mm a')}}</small>
                            <p>{{msg.message}}</p>
                        </div>
                        <div class="person-img1 user-img">
                            <img  :src="current_user_name ? 'https://ui-avatars.com/api/?name='+current_user_name :'../assets/user-icon.png'"  class="img-responsive">
                        </div>
                         <!-- {{msg.created_at | FormatDate('MM/DD/YYYY hh:mm a')}} -->
                    </div>
                </div>
            </div>
            <div id="chat-end"></div>
        </div>

        <div class="row m-t-30">
            <div class="col-sm-12 col-xs-10">
                <div class="form-group textarea-form chat-send-box">
                    <ResizableTextarea ref="resize">
                        <textarea class="form-control" rows="2" id="comment" placeholder="Type your Message" @keyup.enter="pushData()" v-model="send.message" style="resize : none;" v-on:keyup="keyHandler()" ></textarea>
                    </ResizableTextarea>
                    <a  href="javascript://" class="btn-send send_message" @click="pushData()" style="margin-right: 0px; bottom: -10px; color:#000000;" v-bind:class="{active:chat_active}"><svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="paper-plane" class="svg-inline--fa fa-paper-plane fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M440 6.5L24 246.4c-34.4 19.9-31.1 70.8 5.7 85.9L144 379.6V464c0 46.4 59.2 65.5 86.6 28.6l43.8-59.1 111.9 46.2c5.9 2.4 12.1 3.6 18.3 3.6 8.2 0 16.3-2.1 23.6-6.2 12.8-7.2 21.6-20 23.9-34.5l59.4-387.2c6.1-40.1-36.9-68.8-71.5-48.9zM192 464v-64.6l36.6 15.1L192 464zm212.6-28.7l-153.8-63.5L391 169.5c10.7-15.5-9.5-33.5-23.7-21.2L155.8 332.6 48 288 464 48l-59.4 387.3z"></path></svg></a>
                </div>
                <div class="col-sm-12" style="text-align:left;padding-left:20px;">
                    <span v-if="send_err" class="text-danger">
                      Enter you message.
                    </span>
                    </div>
                <!-- <div class="person-img1">
                    <img src="../../assets/images/download.png" class="img-responsive">
                </div> -->
            </div>
        </div>
    </div>
   <!--  <div class="row m-b-40 ">
        <div class="col-sm-1"></div>
        <div class="col-sm-11 send-img">
            
           
        </div>
        <div class="col-sm-12">
            <span v-if="send_err" class="text-danger">
              Enter you message.
            </span>
        </div> -->
        <!-- <div class="col-sm-11"> -->
            <!-- <div class="section-circle sub-circle">
                <span></span><span></span><span></span><span></span>
            </div> -->
             
            <!-- <div class="send-img">
                <a href="javascript://">
                  <img src="../../assets/images/icon-15.png" class="img-responsive"  @click="pushData()" style="width: 25px;">
                </a>
            </div> -->
            
        <!-- </div> -->
</div>
</template>

<script>
import chat from '../services/chat'
import Pusher from 'pusher-js'
import ls from '../services/ls';
import ResizableTextarea from "./ResizableTextarea";
export default {
    name: 'chat',
     components: {
        ResizableTextarea
    },
    data() {
        return {
            current_user_name:ls.get('_u_name'),
            PropData: {},
            chat: {},
            send: {
                sender: 'user',
                message: ''
            },
             pusherKey:process.env.VUE_APP_PUSHER_KEY,
            channel: null,
            send_err:false,
            audio_file:process.env.VUE_APP_URL+'assets/got-it-done.mp3',
           chat_active:false,
            
        }
    },
    props: ['subscription'],
    watch: {
        subscription: function (data) {
            this.PropData = data
            this.GetChat()
        }
    },
    methods: {
        GetChat() {
            chat.get({
                subscription_id: this.PropData.id
            }) 
            .then(res => {
                this.chat = res.data.chat
            })
            var content = this.$refs.messagesContainer;
            content.scrollTop = content.scrollHeight
        },
        pushData() {
            if (this.send.message.trim()!='') {
              this.send_err=false
                this.send.subscription_id = this.PropData.id
                this.chat.push({
                    'message': this.send.message,
                    'sender': this.send.sender
                })
                chat.send(this.send)
                    .then(() => {
                        const el = document.getElementById('chat-end');
                        el.scrollIntoView({behavior: "smooth"});
                        this.send.message = ''
                        // console.log(res)
                    })
            }
            else {
              return this.send_err=true
            }
        },
        PushChat(chatData){
            var Receivedmessage = chatData.chat;
            if(this.PropData.id==Receivedmessage.subscription_id){
                this.playSound();
                this.chat.push({message: Receivedmessage.message,sender:Receivedmessage.sender})
            }
        },
        playSound () {
            var sound =this.audio_file
            if(sound) {
                var audio = new Audio(sound);
                audio.play();
            }
        },
        keyHandler(){
            if(this.send.message != ""){
                this.chat_active = true;
            }else{
             this.chat_active = false;
            }
        }
    },
    created(){
        this.audio_file ='http://127.0.0.1:8000/assets/got-it-done.mp3';
        this.pusher = new Pusher(this.pusherKey, {
            encrypted: true,
            cluster: 'ap2'
        })
        let that = this
        this.channel = this.pusher.subscribe('user_sub_chat_channel')
        this.channel.bind('user_sub_chat_received', function (data) {
            that.$emit('incoming_chat', data)
        })
        this.$on('incoming_chat', function (receivedMessage) {
           this.PushChat(receivedMessage)
        })

    },
    mounted(){
        // console.log(this.audio_file)
    }
};
</script>

